import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { format, parseISO, isValid } from "date-fns";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely format an ISO date string. Returns the fallback ("—" by default) for
 * any null/undefined/malformed input so a single bad row from bulk-upload
 * never crashes the surrounding component (React unmounts the whole subtree
 * if a render throws — which is what blanked the Vehicles + Search screens
 * after the user's first xlsx import with US-formatted dates).
 */
export function safeFormatDate(value, pattern = "dd MMM yyyy", fallback = "—") {
  if (!value) return fallback;
  try {
    const d = typeof value === "string" ? parseISO(value) : value;
    if (!isValid(d)) {
      // Last-chance: try common alternative formats users paste from Excel.
      // (e.g. "12/15/2025" → MM/DD/YYYY, "15-12-2025" → DD-MM-YYYY)
      const s = String(value).trim();
      const m =
        s.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{2,4})$/) ||
        s.match(/^(\d{2,4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})$/);
      if (m) {
        // Heuristic: 4-digit group → year. Other two: assume DD-MM or MM-DD.
        let yr, mo, dy;
        if (m[1].length === 4) {
          [, yr, mo, dy] = m;
        } else if (m[3].length === 4) {
          [, dy, mo, yr] = m;
          // If first part > 12, must be a day → treat as DD-MM-YYYY; else
          // there's genuine ambiguity, fall back to DD-MM convention common
          // outside the US.
        } else {
          return String(value); // give up — show the raw text instead of "—"
        }
        if (yr.length === 2) yr = "20" + yr;
        const iso = `${yr.padStart(4, "0")}-${String(mo).padStart(2, "0")}-${String(dy).padStart(2, "0")}`;
        const d2 = parseISO(iso);
        if (isValid(d2)) return format(d2, pattern);
      }
      return String(value); // show raw text, never crash
    }
    return format(d, pattern);
  } catch (e) {
    // Absolute last-resort: show the raw string, never crash
    return String(value);
  }
}
